import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

const uploadDeliverabilityReportGQL = ({
  reportFile,
  campaignDeliverabilityId,
}) => {
  const query = `
    mutation uploadDeliverabilityReport($input: UploadDeliverabilityReportInput!){
          uploadDeliverabilityReport(input: $input){
                      reportFileUrl
                      campaignDeliverabilityId
                  
         }
      }
  `
  const params = {
    input: {
      reportFile,
      campaignDeliverabilityId,
    },
  }

  return callAuthorizedGraphQLEndpoint(query, params)
}

export { uploadDeliverabilityReportGQL }
